import { memo, useMemo } from 'react';

import dayjs from 'dayjs';

import Chip from '@mui/material/Chip';

import { DataTable } from 'v2/components/dataTable/DataTable';
import { IPagination, Pageable, TableColumn } from 'v2/types';
import { RewardHistory } from 'v2/types/RewardModel';

interface RewardsHistoryTableProps {
  data?: Pageable<RewardHistory>;
  pagination: IPagination;
}

export const RewardsHistoryTable = memo<RewardsHistoryTableProps>(({ data, pagination }) => {
  const columns: TableColumn<RewardHistory>[] = useMemo(
    () => [
      {
        id: 'userNickname',
        key: 'userNickname',
        label: 'User Nickname',
      },
      {
        id: 'value',
        key: 'value',
        label: 'Value',
        ellipsis: true,
      },
      {
        key: 'type',
        label: 'Type',
        render: (row) => <Chip label={row.type} size="small" />,
      },
      {
        key: 'receivedBy',
        label: 'Received By',
        render: (row) => <Chip label={row.receivedBy} size="small" color="primary" />,
      },
      {
        key: 'data',
        label: 'Date',
        align: 'right',
        render: (row) => dayjs(row.date).format('ddd, DD.MM.YYYY HH:mm'),
      },
    ],
    []
  );

  return (
    <DataTable
      columns={columns}
      data={data?.result}
      total={data?.total}
      page={pagination.page}
      pageSize={pagination.pageSize}
      onPageChange={pagination.onPageChange}
      withPagination
    />
  );
});

RewardsHistoryTable.displayName = 'RewardsHistoryTable';
